module.exports = __webpack_public_path__ + "img/s05-bg3.7752448b.png";